import React from "react";
import { Label } from "src/ui";
import Visage2Icon from "src/visage2/Visage2Icon/Visage2Icon";

interface IAcademyCourseSidebarMetaRowProps {
    icon: string;
    name: string;
    value?: string;
}

const AcademyCourseSidebarMetaRow = (props: IAcademyCourseSidebarMetaRowProps) => {
    return (
        <div className="AcademyCourseSidebarMetaRow">
            <Visage2Icon icon={props.icon} size="small" color="grey" />
            <Label size="body-2">{props.name}</Label>
            <div className="AcademyCourseSidebarMetaRow-value">
                {props.value && (
                    <Label size="body-2" color="grey">{props.value}</Label>
                )}
            </div>
        </div>
    )
}

export default AcademyCourseSidebarMetaRow;